export const START_TAG = '({'
export const END_TAG = '})'
